// extracted by mini-css-extract-plugin
export default {"tips":"CopyModal_tips__URyM-"};